import { router } from "expo-router";
import { View, Text, Button } from "@src/components";

interface AppNotConfiguredViewProps {
  onRetry: () => void;
}

export function AppNotConfiguredView({ onRetry }: AppNotConfiguredViewProps) {
  return (
    <View flex={1} alignItems="center" justifyContent="center" bg="background" px="6xl" gap="lg">
      <Text textStyle="xl" fontWeight="600" textAlign="center">
        App not configured
      </Text>
      <Text textStyle="md/regular" color="textMuted" textAlign="center">
        We couldn&apos;t load your app configuration. Please check your internet connection and try again.
      </Text>
      <Button label="Retry" variant="primary" onPress={onRetry} />
      <Button label="Logout" variant="secondary" onPress={() => router.push("/auth/logout")} />
    </View>
  );
}
